/** Topic name on the shared application socket, matching
 * USER_PRESENCE_TOPIC in apps/users/services/presence_events.py. */
export const USER_PRESENCE_TOPIC = 'users.presence';
